import { useUserStore } from './userStore.js'
const PiniaStore = {
    install(app) {
        app.config.globalProperties.$userStore = useUserStore()
     }
}
export default PiniaStore